import React from "react";
import { components } from "react-select";

const CustomOption = (props: any) => {
  const { isSelected, children } = props;
  return (
    <components.Option
      {...props}
      className={`optWrap ${isSelected ? "active" : ""}`}
    >
      {children}
    </components.Option>
  );
};

export default CustomOption;
